import { gql } from '@apollo/client'
import { IQueryBasicData } from '../IQueryData'
import { IReservationVariant } from './getParkingPoolAvailability'

export interface IGetParkingPoolReservationVariantsVars {
  login: string
  days: string[]
}

export interface IGetParkingPoolReservationVariantsData {
  getParkingPoolReservationVariants: IQueryBasicData & {
    orderingEnabled: boolean
    variants: IReservationVariant[]
  }
}

export const GET_PARKING_POOL_RESERVATION_VARIANTS = gql`
  query getParkingPoolReservationVariants(
    $login: String!
    $days: [DateTime!]!
  ) {
    getParkingPoolReservationVariants(login: $login, days: $days) {
      status
      code
      error
      message
      orderingEnabled: ordering_enabled
      variants {
        score
        days {
          day
          parkingName: parking_name
          poolParkingId: pool_parking_id
          available
          reason
          reasonCode: reason_code
        }
      }
    }
  }
`
